import { Component, Inject, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ObjektModels } from 'src/app/models/objekt-models';
import { SwissInternService } from 'src/app/services/swiss-intern.service';

@Component({
  selector: 'app-objekt-schutz',
  templateUrl: './objekt-schutz.component.html',
  styleUrls: ['./objekt-schutz.component.scss']
})
export class ObjektSchutzComponent implements OnInit {

  @Input() formGroupObjPW: UntypedFormGroup;

  constructor(
    private svcSwissIntern: SwissInternService,
    public dialogRef: MatDialogRef<ObjektSchutzComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ObjektModels.ObjektElement) { 

      this.formGroupObjPW = new UntypedFormGroup({
        fldObj: new UntypedFormControl(),
        fldObjPW: new UntypedFormControl(),
      })
    }

  ngOnInit(): void {
    this.formGroupObjPW.controls['fldObj'].setValue(this.data.description);
    this.formGroupObjPW.controls['fldObj'].disable();
  }

  checkPW() {
    let pw = this.formGroupObjPW.controls['fldObjPW'].value;
    this.dialogRef.close(this.svcSwissIntern.getEncryptedValue(pw).toLowerCase() === this.data.password?.toLocaleLowerCase());
  }

}
